"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18nBizContentApi = i18nBizContentApi;
exports.i18nBizStatusBatchApi = i18nBizStatusBatchApi;
exports.i18nLanguagesApi = i18nLanguagesApi;
exports.i18nSaveBizContentApi = i18nSaveBizContentApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function i18nLanguagesApi() {
  return (0, _request.default)({
    url: '/admin/i18n/languages',
    method: 'GET'
  });
}
function i18nBizContentApi(params) {
  return (0, _request.default)({
    url: '/admin/i18n/biz/content',
    method: 'GET',
    params: params
  });
}
function i18nBizStatusBatchApi(params) {
  return (0, _request.default)({
    url: '/admin/i18n/biz/status/batch',
    method: 'GET',
    params: params
  });
}
function i18nSaveBizContentApi(data) {
  return (0, _request.default)({
    url: '/admin/i18n/biz/save',
    method: 'POST',
    data: data
  });
}